/**
 * Devuelve un objeto simple {key: value} transformando el json en entrada
 *
 * @param {Object} data las traducciones en formato json
 * @param {string} [parentpath=''] NO USAR, este parametro sirve para la llamada recursiva interna.
 * @returns {Object} {key: value, ...}
 *
 * @example
 * const json = {
 *   global: {
 *     "insertLine": "Insertar nueva linea",
 *     "cancel": "Cancelar",
 *   }
 * }
 * const res = flattenJson(json);
 * // res:
 * // {
 * //   global.insertLine: 'Insertar nueva linea',
 * //   global.cancel: 'Cancelar'
 * // }
 */
export function flattenJson(json = {}, parentpath = '') {
  return Object.entries(json).reduce((acc, [key, value]) => {
    const path = `${parentpath}${key}`;

    if (typeof value === 'object') {
      return Object.assign(acc, flattenJson(value, `${path}.`));
    }

    if (typeof value === 'string') {
      acc[path] = value;
    }

    return acc;
  }, {});
}
